export default __webpack_public_path__ + "assets/44d3bfbf88b584772f4f2cbe62cb5983.png";